import { render, staticRenderFns } from "./DeleteBatch.vue?vue&type=template&id=32f09a62&"
import script from "./DeleteBatch.vue?vue&type=script&lang=js&"
export * from "./DeleteBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3043685859/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f09a62')) {
      api.createRecord('32f09a62', component.options)
    } else {
      api.reload('32f09a62', component.options)
    }
    module.hot.accept("./DeleteBatch.vue?vue&type=template&id=32f09a62&", function () {
      api.rerender('32f09a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeleteBatch.vue"
export default component.exports